// extracted by mini-css-extract-plugin
export var originalPrice = "_us-0";